/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { action, observable } from "mobx";
import { LM_PERSONALISATION } from "constants/constants";

class LiquidModePersonalisationStore {
  @observable fontSize = null;
  @observable lineHeight = null;
  @observable letterSpacing = null;

  constructor() {
    this.init();
  }

  initStore(docApi, stores) {
    if (docApi) {
      this.docApi = docApi;
    }
    if (stores) {
      this.stores = stores;
    }
  }

  @action
  init() {
    const { defaultFontSize, defaultLineHeight, defaultLetterSpacing } = LM_PERSONALISATION;
    this.fontSize = defaultFontSize;
    this.lineHeight = defaultLineHeight;
    this.letterSpacing = defaultLetterSpacing;
  }

  @action
  setFontSize(fontSize) {
    this.fontSize = fontSize;
  }

  @action
  setLineHeight(lineHeight) {
    this.lineHeight = lineHeight;
  }

  @action
  setLetterSpacing(letterSpacing) {
    this.letterSpacing = letterSpacing;
  }
}

export { LiquidModePersonalisationStore };
